
import Vue from 'vue'
import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'
import { PartyCreditCardOptionModel } from '@ViewModels/PartyCreditCardOptionModel'
import { DropDownSelect } from '@/components/formGroups'
import NewCard from './PaymentMethodNewCreditCard.vue'

export default Vue.extend({
   name: 'PaymentMethodCreditCard',
   data() {
      return {
         selectedCardId: 'new',
         data: {
            NameOnCard: '',
            CardNumber: '',
            CardExpiryMonth: 0,
            CardExpiryYear: 0,
         },
      }
   },
   computed: {
      modelData(): CheckoutPageModel {
         return this.$store.state.modelData
      },
      creditCards(): PartyCreditCardOptionModel[] {
         return this.$store.state.modelData.CreditCards
      },
      creditCardOptions(): NameValuePair[] {
         const options = this.creditCards.map(card => ({
            name: `${card.NameOnCard} ending in ${card.CardNumberEndingIn}, expires ${card.ExpiryMonth}/${card.ExpiryYear}`,
            value: card.Id,
         }))
         options.push({ name: '', value: '-' })
         options.push({ name: 'Add new card', value: 'new' })
         return options
      },
      showErrors(): boolean {
         return this.$store.state.showErrors
      },
   },
   methods: {
      update() {
         const card = this.creditCards.find(c => c.Id === this.selectedCardId)
         if (card) {
            this.$store.commit('setExistingCreditCardData', {
               CreditCardId: this.selectedCardId,
               CardNumber: card.CardNumberEndingIn,
            })
         }
      },
   },
   mounted() {
      if (!!this.$store.state.purchase.CreditCardId) {
         this.selectedCardId = this.$store.state.purchase.CreditCardId
         return
      }
      if (this.modelData.CreditCards.length > 0) {
         this.selectedCardId = ''
      }
   },
   components: {
      NewCard,
      DropDownSelect,
   },
})
